export default {
  user: state => state.user,
  globalTimePeriod: state => state.globalTimePeriod
};
